// extracted by mini-css-extract-plugin
module.exports = {"button":"LinkButton_button__2zaD6 btn","link":"LinkButton_link__vpQsU LinkButton_button__2zaD6 btn"};